import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import type { AssetListItem } from '@/api/types'
import { FAMILIES, OTHER_FAMILY as OTHER, classify } from '@/lib/cryptoFamily'

ChartJS.register(ArcElement, Tooltip, Legend)

export function CryptoInventoryDonut({ assets }: { assets: AssetListItem[] }) {
  const counts = new Array(FAMILIES.length).fill(0)
  let other = 0
  for (const a of assets) {
    const i = classify(a.algorithm)
    if (i < 0) other++
    else counts[i]++
  }

  const entries = FAMILIES.map((f, i) => ({ ...f, value: counts[i] })).filter((e) => e.value > 0)
  if (other > 0) entries.push({ ...OTHER, value: other, test: /$^/ })

  const data = {
    labels: entries.map((e) => e.label),
    datasets: [
      {
        data: entries.map((e) => e.value),
        backgroundColor: entries.map((e) => e.color),
        borderWidth: 0,
      },
    ],
  }
  return (
    <Doughnut
      data={data}
      options={{
        cutout: '55%',
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: 'right', labels: { boxWidth: 10, padding: 8, font: { size: 11 } } } },
      }}
    />
  )
}
